import React from 'react';
import AnimatedLogo from './AnimatedLogo';
import './ConnectionErrorScreen.css';

const ConnectionErrorScreen = ({ onRetry, onSignOut }) => (
  <main className="clerk-auth-container connection-error-screen app-content-fade-in">
    <div className="connection-error-stack">
      <AnimatedLogo />
      <section className="connection-error-card" role="alert" aria-labelledby="connection-error-title">
        <div className="connection-error-status">
          <span className="connection-error-status-dot" aria-hidden="true" />
          Unable to reach Kata.fit
        </div>
        <div className="connection-error-copy">
          <h1 id="connection-error-title">Connection interrupted</h1>
          <p>Your account is safe. Kata.fit can’t reach the service right now. Check your connection, then try again.</p>
        </div>
        <div className="connection-error-actions">
          <button type="button" className="connection-error-retry" onClick={onRetry}>Try again</button>
          <button type="button" className="connection-error-signout" onClick={onSignOut}>Sign out</button>
        </div>
      </section>
    </div>
  </main>
);

export default ConnectionErrorScreen;
